import { type ActionCableMixin, type Message } from '@anycable/core'
import { type MessageStructure } from './types'

export class CableSubscriptionEventHandler<T extends Message, M extends ActionCableMixin<T>> {
  received: (message: T) => void = () => {}
  initialized: () => void = () => {}
  connected: () => void = () => {}
  disconnected: () => void = () => {}
  rejected: () => void = () => {}
  constructor(readonly identifier: string, { received, initialized, connected, disconnected, rejected }: M) {
    if (received) this.received = received
    if (initialized) this.initialized = initialized
    if (connected) this.connected = connected
    if (disconnected) this.disconnected = disconnected
    if (rejected) this.rejected = rejected
  }
  handleMessage(message: MessageStructure) {
    // TODO: Should use a decoder, we should still be able to go to binary
    const data = typeof message === 'string' ? JSON.parse(message) : message
    if (data.identifier === this.identifier && data.message) {
      // NOTICE: It does not make a lof of sense to me but sometimes for RealTimeChannel it doesn't come stringified
      const parseMessage = typeof data.message === 'string' ? JSON.parse(data.message) : data.message
      this.received(parseMessage)
    }
    // By the design of the reconnection and etc we may see this being called multiple times
    if (data.identifier === this.identifier && data.type === 'confirm_subscription') {
      this.connected()
    }
    // This is the only case where we reject, all other errors are silenced
    if (data.identifier === this.identifier && data.type === 'reject_subscription') {
      this.rejected()
    }
  }
}
